import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

/**
 * The `ColumItem` component is a React component that displays a column item with a label and value.
 * @component
 * @param {Object} props - The props of the component
 * @param {string} props.label - The label of the column item
 * @param {string | number} props.value - The value of the column item
 * @returns {React.ReactElement} The `ColumItem` component
 */
const ColumItem = ({ label, value }) => {
  return (
    <Box flexBasis={{ xs: "100%", sm: "calc(50% - 8px)" }}>
      <Typography component="h3" variant="inputLabel" color="text.secondary" sx={{ mb: 3 }}>
        {label}
      </Typography>
      <Typography component="p" variant="body2" color="text.primary">
        {value ?? "-"}
      </Typography>
    </Box>
  );
};

export default ColumItem;
